import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for list  trade history
export const backreport = createSlice({
  name: "backreport",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFirst: true,
    data: [],
  },
  reducers: {
    list_backreport: (state, action?) => {
      state.isLoading = true;
    },
    success_api_call_backreport: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.isFirst = true;
    },
    failure_api_call_backreport: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
    },
    backreport_is_first: (state, action) => {
      state.isFirst = false;
    },
    clearDatabackreport: (state) => {
      state.data = [];
    },
  },
});
export default backreport.reducer;
export const {
  list_backreport,
  success_api_call_backreport,
  failure_api_call_backreport,
  backreport_is_first,
  clearDatabackreport,
} = backreport.actions;
